import Store from '../../store/index';
import getProfile from "../../store/actions/getProfile";
import getUserGroups from "../../store/actions/getUserGroups";
import getVehicleCategory from "../../store/actions/getVehicleCategory";
import getVehicleLevel from "../../store/actions/getVehicleLevel";
import getCity from "../../store/actions/getCity";

export default (to, from, next) => {
  if (!Store.state.token) next({ name: 'Login' });
  else {
    if(!Store.state.profile) {
      getProfile()
          .then(getUserGroups)
          .then(getVehicleCategory)
          .then(getVehicleLevel)
          .then(getCity)
          .then(next);
    } else {
      next();
    }
  }
}
